import { API_AUTH_URL } from 'configs/AppConfig';
import { THEME_META } from './themeMeta';

const ORG_CODE = () => process.env.REACT_APP_ORGANIZATION || 'nagaco';
const PUBLIC_URL = () => process.env.PUBLIC_URL || '';

const shouldShowWhen = (when, collapsed) => {
    switch (when) {
        case 'collapsed':
            return collapsed;
        case 'expanded':
            return !collapsed;
        case 'always':
        default:
            return true;
    }
};

const pickThemeAsset = (logoMeta, collapsed, contrastMode) => {
    if (!logoMeta) return null;

    const useLight = contrastMode === 'light';
    if (collapsed) {
        if (useLight && logoMeta.smLight) return logoMeta.smLight;
        if (!useLight && logoMeta.smDark) return logoMeta.smDark;
        return logoMeta.sm ?? null;
    }

    if (useLight && logoMeta.fullLight) return logoMeta.fullLight;
    if (!useLight && logoMeta.fullDark) return logoMeta.fullDark;
    return logoMeta.full ?? null;
};

/** Logo chính — ưu tiên asset theo theme, fallback org API + biến thể sáng/tối */
export const getThemeLogoSrc = (themeKey, { collapsed = false, contrastMode = 'dark' } = {}) => {
    const themeAsset = pickThemeAsset(THEME_META[themeKey]?.logo, collapsed, contrastMode);
    if (themeAsset) {
        return themeAsset;
    }

    const apiBase = `${API_AUTH_URL}api/openid_files/organization/${ORG_CODE()}`;
    const useLight = contrastMode === 'light';

    if (collapsed) {
        return useLight ? `${PUBLIC_URL()}/img/logo-sm-white.png` : `${apiBase}-sm.png`;
    }

    return useLight ? `${PUBLIC_URL()}/img/logo-white.png` : `${apiBase}.png`;
};

/** Trang trí (cành cờ, Noel, …) và badge nhỏ cạnh logo */
export const getThemeLogoExtras = (themeKey, { collapsed = false } = {}) => {
    const logoMeta = THEME_META[themeKey]?.logo;
    if (!logoMeta) {
        return { decoration: null, badge: null };
    }

    const decoration =
        logoMeta.decoration && shouldShowWhen(logoMeta.decorationWhen ?? 'expanded', collapsed)
            ? {
                  src: logoMeta.decoration,
                  className: logoMeta.decorationClassName ?? 'theme-logo-decoration',
              }
            : null;

    const badge =
        logoMeta.badge && shouldShowWhen(logoMeta.badgeWhen ?? 'expanded', collapsed)
            ? {
                  src: logoMeta.badge,
                  className: logoMeta.badgeClassName ?? 'theme-logo-badge',
              }
            : null;

    return { decoration, badge };
};
